import React, { useState } from 'react';
import { Redirect} from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import jwt from 'jwt-decode';
import withSizes from 'react-sizes';

import log from '../../services/log';
import ga from '../../services/ga';
import auth from '../../services/auth';
import PasswordSignInDialog from '../auth/PasswordSignInDialog';
import { isPrerendering } from '../../services/prerender';

const isFirebasePasswordAuthEnabled = process.env.REACT_APP_FIREBASE_PASSWORD_AUTH === 'true';

function SignInButton(props){

  const [isLogged, setIsLogged] = useState(false);
  const [showPasswordSignIn, setShowPasswordSignIn] = useState(false);

  const handleSignedIn = user => {
    if (props.onSignedIn) {
      props.onSignedIn(user);
      return;
    }
    setIsLogged(true);
  };

  const authGoogleHandler = async (response) => {
    log.traceTag('Google Object', response)
    try {
      const userProfile = response?.credential ? jwt(response.credential) : null;
      log.traceTag('userProfile', userProfile)

      if (userProfile?.name && userProfile?.email){
        const user = await auth.signIn(userProfile.name, userProfile.email, userProfile.picture)
        log.traceTag('sign in user', user)
        if (props.subscribe && user){
          ga.track({
            category: 'Retention',
            action: 'subscribed',
          })
        }
        handleSignedIn(user);
      } else {
        setIsLogged(false);
        ga.track({
          category: 'signinError',
          action: 'signinError',
        });
      }
    } catch (e) {
      log.error(e);
      setIsLogged(false);
      ga.track({
        category: 'signinError',
        action: 'signinError',
      });
    }
  }

  
  if (isLogged && props.redirectTo) {
    return <Redirect to={{
      pathname: props.redirectTo
    }}/>;
  }

  if (isPrerendering()) {
    return (
      <div className={`sign-in-cta sign-in-cta-${props.align}`}>
        <div className="sign-in-methods">
          <button type="button" className="sign-in-email-link" disabled>Sign In to GoldAPI.io</button>
        </div>
        <div className={`my-2 sign-in-caption sign-in-caption-${props.align}`}>
          <span className="text-muted">Set Up In <b>30 Seconds</b>. <b>No Card</b> Required.</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={`sign-in-cta sign-in-cta-${props.align}`}>
        <div className="sign-in-methods">
          <div className="sign-in-google-login" data-effect="solid" data-place="bottom" data-class="tooltip" data-tip="Can't Sign In in Firefox or Brave? Enable Cross-Site (Third-Party) Cookies or try to use Chrome!" style={{ display: "inline-block", width: "auto" }}>
            <GoogleLogin
              onSuccess={authGoogleHandler}
              onError={() => {
                ga.track({
                  category: 'signinError',
                  action: 'signinError',
                });
              }}
              text="signin_with"
              theme="filled_blue"
              shape="pill"
              ux_mode="popup"
            />
          </div>
          {isFirebasePasswordAuthEnabled && (
            <button
              type="button"
              className="sign-in-email-link"
              onClick={() => setShowPasswordSignIn(true)}
            >
              Sign In with Email
            </button>
          )}
        </div>
        <div className={`my-2 sign-in-caption sign-in-caption-${props.align}`}>
          <span className='text-muted'>Set Up In <b>30 Seconds</b>. <b>No Card</b> Required. </span> &nbsp;
        </div>
      </div>
      {isFirebasePasswordAuthEnabled && (
        <PasswordSignInDialog
          show={showPasswordSignIn}
          onClose={() => setShowPasswordSignIn(false)}
          onSignedIn={handleSignedIn}
        />
      )}
    </>     
  );
};

SignInButton.defaultProps = {
  text: 'Get FREE API Key or Sign In',
  outlined: true,
  raised: true,
  subscribe: false,
  bold: false,
  color: 'white',
  align: 'center',
  redirectTo: '/dashboard'
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
  isDesktop: width >= 1024
})


export default withSizes(mapSizesToProps)(SignInButton);
